import React from 'react';
import PropTypes from 'prop-types';

import OnDeleteIcon from '../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../icons/OnEditIcon';
import { formatToMonthYear } from '../../../utils/dateFunctions';

import card from '../../../commonStyles/card.module.css';

const EducationCard = ({
    institution,
    qualificationTypes,
    isDisabled = false,
    onEditInstitution,
    onDeleteInstitution
}) => {
    const { name, qualificationTypeId, subjects, startDate, endDate } = institution;

    const findName = (id) => qualificationTypes?.find((el) => el.id === id)?.name || '';

    return (
        <div className={card.card} data-testid="past_education_card">
            <div
                className={`${
                    name?.length > 40 ? card.bannerTwoRowWithActions : card.bannerWithActions
                }`}>
                <h6>{name || 'Past Education'}</h6>
                {!isDisabled && (
                    <div className={card.bannerActions}>
                        <span className={card.editIcons} data-testid="education_card_icons">
                            <OnEditIcon
                                onEdit={() => onEditInstitution(institution)}
                                active={!isDisabled}
                            />
                            <OnDeleteIcon
                                onDelete={() => onDeleteInstitution(institution.id)}
                                active={!isDisabled}
                            />
                        </span>
                    </div>
                )}
            </div>
            <div className={card.content}>
                <div className={card.copy}>
                    <p>
                        <span>
                            {startDate ? formatToMonthYear(startDate) : ''}
                            {endDate ? ` - ${formatToMonthYear(endDate)}` : ''}
                        </span>
                    </p>
                    <p>
                        <span>Qualification Type:</span>
                        {qualificationTypeId ? findName(qualificationTypeId) : ' - '}
                    </p>
                    <p>
                        <span>Subjects: </span>
                        <span className={card.list}>
                            {subjects &&
                                subjects.map((el) => (
                                    <span key={el.subject} className={card.listItem}>
                                        {`${el.subject}: ${el.grade || ' - '}`}
                                    </span>
                                ))}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );
};

EducationCard.propTypes = {
    institution: PropTypes.object,
    qualificationTypes: PropTypes.arrayOf(PropTypes.object),
    isDisabled: PropTypes.bool,
    onEditInstitution: PropTypes.func,
    onDeleteInstitution: PropTypes.func
};

export default EducationCard;
